import { useMemo } from "react"
import { useQuery } from "urql"

import {
  type Company,
  CompanyListDetailsDocument,
  type CompanyListDetailsQuery,
  type CompanyListDetailsQueryVariables,
} from "@/graphql/codegen/graphql"
import { COMPANY_TYPE } from "@/screens/Companies/constants"

const CARRIERS_DROPDOWN_LIMIT = 1000 // Fetch all carriers for dropdown (no pagination needed)

export const useGetTransportationCompanies = (): {
  companies: Company[]
  isFetching: boolean
} => {
  const [{ data, fetching }] = useQuery<CompanyListDetailsQuery, CompanyListDetailsQueryVariables>({
    query: CompanyListDetailsDocument,
    variables: {
      input: {
        filter: { types: [COMPANY_TYPE.TRANSPORTATION] },
        limit: CARRIERS_DROPDOWN_LIMIT,
        offset: 0,
      },
    },
  })

  const companies = useMemo<Company[]>(() => {
    if (data?.company.list.__typename !== "CompanyListSuccess") {
      return []
    }
    return data.company.list.companies as Company[]
  }, [data])

  return {
    companies,
    isFetching: fetching,
  }
}
